import { render, staticRenderFns } from "./alarms-chart.vue?vue&type=template&id=ba8d0ce2&"
import script from "./alarms-chart.vue.js?vue&type=script&lang=js&"
export * from "./alarms-chart.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports